import { cva } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva(
    "inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-0 disabled:pointer-events-none disabled:opacity-50",
    {
        variants: {
            variant: {
                default: "",
                primary:
                    "bg-button-primary-bg text-button-primary-fg border border-button-primary-border hover:bg-button-primary-bg_hover hover:border-button-primary-border_hover disabled:bg-disabled disabled:fg-disabled disabled:border-disabled_subtle",
                outline:
                    "bg-button-secondary-gray-bg text-button-secondary-gray-fg hover:button-secondary-gray-bg_hover border border-button-secondary-gray-border hover:border-button-secondary-gray-border_hover disabled:opacity-100 disabled:border-disabled_subtle disabled:shadow-sm disabled:fg-quinary",
                destructive:
                    "bg-button-primary-error-bg text-button-primary-error-fg hover:bg-button-primary-error-bg/90 border border-button-primary-error-bg",
                destructiveOutline:
                    "border border-button-primary-error-bg text-button-primary-error-bg hover:bg-button-primary-error-bg/10",
                constructive:
                    "bg-button-primary-success-bg text-button-primary-success-fg hover:bg-button-primary-success-bg/90 border border-button-primary-success-bg",
                ghost: "hover:text-accent-foreground",
                property: "text-sm/tight font-medium capitalize rounded-full",
                badge: "text-sm leading-5 font-medium text-utility-gray-700 bg-white border border-primary rounded-lg",
            },
            padding: {
                none: "",
                default:
                    "py-4 md:py-3 lg:py-2.5 px-5.5 md:px-4.5 lg:px-4 gap-2.5 md:gap-1.5",
                "action-bar": "py-2 px-3 gap-1",
                icon: "p-2",
                "icon-small": "p-[7px]",
                property: "pl-1 md:pl-0.5 pr-3.5 gap-2 md:gap-1.5",
                badge: "py-px px-1.5",
            },
            size: {
                default: "",
                grow: "grow",
                full: "w-full",
                "action-bar": "h-11.5",
                property: "h-10 md:h-7",
            },
        },
        compoundVariants: [
            {
                variant: "property",
                empty: true,
                class: "text-utility-gray-500 bg-utility-gray-50 border-utility-gray-300",
            },
            {
                variant: "property",
                empty: false,
                class: "text-primary bg-utility-brand-50",
            },
        ],
        defaultVariants: {
            variant: "default",
            padding: "default",
            size: "default",
            empty: false,
        },
    }
);
